import React from 'react';
import './button.style.scss'; // Make sure to include your stylesheet

const Button = ({ text, option, onClick }) => {
    return (
        <div>
            {option === 'green' && (
                <div onClick={onClick} className='button-green'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'blue-inverted' && (
                <div onClick={onClick} className='button-blue-inverted'>
                    <p>{text}</p>
                </div>
            )}
            {option === 'blue-inverted-no-hover' && (
                <div onClick={onClick} className='button-blue-inverted-no-hover'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'yellow' && (
                <div  onClick={onClick} className='button-yellow'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'yellow-clicked' && (
                <div  onClick={onClick} className='button-yellow-clicked'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'inactive' && (
                <div onClick={onClick} className='button-inactive'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'red' && (
                <div onClick={onClick} className='button-cancel'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'button-linked-text' && (
                <div onClick={onClick} className='button-linked-text'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {!option && (
                <div onClick={onClick} className='button'>
                    <p className='text'>{text}</p>
                </div>
            )}
        </div>
    );
};

export default Button;